import React from 'react';
// /////////////////////////////////////////////////////////////////////////////////////////////////
const themeState = {
	paletteMode: 'light', //'dark' : 'light'
};

const themeItem = JSON.parse(localStorage.getItem('store.theme'));
if (themeItem) {
  if (themeItem.paletteMode !== undefined && (themeItem.paletteMode === 'light' || themeItem.paletteMode === 'dark'))
    themeState.paletteMode = themeItem.paletteMode
}

const theme = (state = themeState, { type, ...rest }) => {
	switch (type) {
		case 'theme/set':
			return { ...state, ...rest };

		case 'theme/paletteMode':
			var paletteMode = (state.paletteMode === 'light') ? 'dark' : 'light'
			localStorage.setItem('store.theme', JSON.stringify({ paletteMode: paletteMode }));
			return { ...state, paletteMode: paletteMode };

		default:
			return state;
	}
};

export default theme;
